<template>
  <router-view v-if="$beet.isReady" @burger="navOpen = !navOpen" @imageViewer="openModal" />
  <SiteFooter v-if="$beet.isReady" />
  <SiteNav :is-open="navOpen" @close="navOpen = false" v-if="$beet.isReady" />
  <Gdpr />
  <ImageModal
    v-if="showImageModal"
    :images="modalDataImages"
    :image="modalCurrentImage"
    @close="showImageModal = false"
  />
</template>

<script>
import Gdpr from '@/components/gdpr/Gdpr.vue'
import ImageModal from '@/components/ImageModal.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import SiteNav from '@/components/SiteNav.vue'
import { useLangRouter } from '@/extensions/langRouter/index.js'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: { Gdpr, SiteFooter, SiteNav, ImageModal },
  data() {
    return {
      navOpen: false,
      showImageModal: false,
      modalDataImages: null,
      modalCurrentImage: null,
    }
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
  methods: {
    openModal(images, image) {
      this.modalDataImages = images
      this.modalCurrentImage = image
      this.showImageModal = true
    },
  },
}
</script>
